// src/components/AttendanceFilters.js
import React, { useState, useEffect } from "react";
import { CardContent, Stack, CardHeader } from "@mui/material";

import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";

import { getDaysInMonth } from "date-fns";
import { useUserDetails } from "../../../context/auth";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";

import { useLoading } from "../../../context/loading";
import { fetchAll } from "../../../ApiBaseUrl";
import request, { gql } from "graphql-request";
function AttendanceFilters({ fromDateRef, endDateRef }) {
  const {
    totaldays,
    settotaldays,
    setallyears,
    setallmonth,
    setfromdate,
    setenddate,
    setEmployeeCategory,
    setEmployeeType,
    setBranches,
    setShifts,
    employeeName,
    setemployeeName,
  } = useUserDetails();

  const [fromDate, setFromDate] = useState("");
  const [tillDate, setTillDate] = useState("");
  const [branch, setBranch] = useState("");
  const [emplytype, setempyType] = useState("");
  const [emplyCate, setEmplyCate] = useState("");
  const [shift, setShift] = useState("");
  const [shiftList, setShiftList] = useState([]);
  const { setCirleLoading } = useLoading();

  const [allbranchnames, setallbranchnames] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employee, setEmplyoee] = useState("");

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  const startYear = 2000;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  const yearOptions = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonths = new Date().getMonth();

  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });
  const [selectedMonth, setSelectedMonth] = useState({
    value: currentMonth,
    label: monthNames[currentMonth],
  });
  const monthOptions = () => {
    let month;
    if (selectedYear?.value) {
      if (currentYear == selectedYear?.value) {
        month = monthNames.slice(0, currentMonths + 1).map((month, index) => ({
          value: index,
          label: month,
        }));
      } else {
        month = monthNames.map((month, index) => ({
          value: index,
          label: month,
        }));
      }
    } else {
      month = monthNames.map((month, index) => ({
        value: index,
        label: month,
      }));
    }
    return month;
  };

  const currentDate = new Date();
  useEffect(() => {
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const year = selectedYear.value;
    const month = selectedMonth.value;

    const startOfMonth = new Date(year, month, 1);

    const endOfMonth =
      year === currentYear && month === currentMonth
        ? currentDate
        : new Date(year, month + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFromDate(formatDate(startOfMonth));
    setTillDate(formatDate(endOfMonth));
    setfromdate(formatDate(startOfMonth));
    setenddate(formatDate(endOfMonth));
  }, [selectedMonth, selectedYear]);

  const formatDate = (year, month, day) => {
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };
  const typedata = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ];
  const emptype = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      const employeeAndId = gql`
        query {
          allUsersDetail {
            id
            firstName
            lastName
            empid
            email
            category
          }
        }
      `;
      try {
        const resp = await request(BASEURL, employeeAndId);

        if (resp?.allUsersDetail) {
          const formattedEmployees = resp.allUsersDetail.map((user) => ({
            value: user.id,
            label: user.firstName + " " + user.lastName,
            empid: user.empid,
            category: user.category,
          }));

          setEmployeeOptions(formattedEmployees);
        }
      } catch (error) {
        console.error("Error fetching Employee Details", error);
      }
    };

    fetchEmployeeDetails();
  }, []);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        
        const data = await fetchAll("Branch", fields);
        let result = data?.allBranch;
        let filterdata = result.map((val) => {
          return {
            value: val.id,
            label: val.name,
          };
        });
        setallbranchnames(filterdata);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    fetchBranches();
  }, []);
  const onShiftDetails = async () => {
    const query = `
    query allShifts{
allShifts {
id
name
startTime
endTime
}
}
    `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const shiftData = response.data?.data?.allShifts;
      if (shiftData) {
        setShiftList(shiftData);
      } else {
        console.error("Error: Shift data not found in response.");
      }
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };
  const userDetails = sessionStorage.getItem("user");
  const parsedData = JSON.parse(userDetails);
  const encodedId = btoa(parsedData?.id);

  useEffect(() => {
    onShiftDetails();
  }, []);
  useEffect(() => {
    if (selectedYear && selectedMonth) {
      setallyears(selectedYear);
      setallmonth(selectedMonth);
      setBranches(branch);
      setfromdate(fromDate);
      setenddate(tillDate);
      setShifts(shift);
      setEmployeeCategory(emplyCate);
      setEmployeeType(emplytype);
      setemployeeName(employee);
      const lastDay = getDaysInMonth(
        new Date(selectedYear.value, selectedMonth.value),
      );

      settotaldays(lastDay);
    }
  }, [
    selectedYear,
    selectedMonth,
    fromDate,
    tillDate,
    shift,
    totaldays,
    branch,
    emplyCate,
    emplytype,
    employee,
  ]);

  const handleFromDateChange = (event) => {
    const selectedDate = event.target.value;
    setFromDate(selectedDate);

    if (tillDate < selectedDate) {
      setTillDate(selectedDate);
    }
  };

  // Handle change in the 'Till' date
  const handleTillDateChange = (event) => {
    setTillDate(event.target.value);
  };

  const onChangeHandelar = (event, type) => {
    console.log(event, type, "type");
    if (type == "shift") {
      setShift(event);
    } else if (type == "branch") {
      setBranch(event);
    } else if (type == "emplytype") {
      setempyType(event);
    } else if (type == "employeeName") {
      setEmplyoee(event);
    } else {
      setEmplyCate(event);
    }
  };

  return (
    <div
      style={{
        zIndex: 2,
        padding: "30px 0px",
      }}
    >
      <CardContent>
        <MaterialBox>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Attendance
                  </MaterialTypography>
                </Stack>
              </Stack>
            }
          ></CardHeader>

          <Grid container spacing={2}>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Year
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="year"
                options={yearOptions}
                value={selectedYear}
                onChange={(year) => setSelectedYear(year)}
                customStyles={{ optionPadding: 20 }}
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Month
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="month"
                options={monthOptions()}
                value={selectedMonth}
                onChange={(month) => setSelectedMonth(month)}
                customStyles={{ optionPadding: 20 }}
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  From
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                ref={fromDateRef}
                name="fromDate"
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
              />
            </Grid>

            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Till
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                ref={endDateRef}
                name="tillDate"
                type="date"
                value={tillDate}
                onChange={handleTillDateChange}
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
              />
            </Grid>

            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Shifts
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={shift}
                customStyles={{ optionPadding: 20 }}
                onChange={(e) => onChangeHandelar(e, "shift")}
                options={shiftList?.map((item) => {
                  return {
                    value: item?.name,
                    label: item?.name,
                  };
                })}
                isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Branch
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={branch}
                customStyles={{ optionPadding: 20 }}
                onChange={(e) => onChangeHandelar(e, "branch")}
                options={allbranchnames?.map((item) => {
                  return {
                    value: item?.value,
                    label: item?.label,
                  };
                })}
                isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee Type
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={emplytype}
                customStyles={{ optionPadding: 20 }}
                onChange={(e) => onChangeHandelar(e, "emplytype")}
                options={emptype?.map((item) => {
                  return {
                    value: item?.value,
                    label: item?.label,
                  };
                })}
                isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee Category
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={emplyCate}
                customStyles={{ optionPadding: 20 }}
                onChange={(e) => onChangeHandelar(e, "emplyCate")}
                options={typedata?.map((item) => {
                  return {
                    value: item?.value,
                    label: item?.label,
                  };
                })}
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, lg: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="emplyoee"
                options={employeeOptions}
                value={employee}
                onChange={(e) => onChangeHandelar(e, "employeeName")}
                customStyles={{ optionPadding: 20 }}
                isClearable
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
    </div>
  );
}

export default AttendanceFilters;
